import { useEffect } from 'react';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

// Inertia-style smooth scrolling (same Lenis settings as armadaclub.com).
// The instance is shared on window.__lenis so other components can drive it.
function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined;
    }

    const lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 0.8, syncTouch: false });
    window.__lenis = lenis;

    let frame = requestAnimationFrame(function raf(time) {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    });

    // Pause while typing in form fields so the page doesn't drift.
    const isField = (el) =>
      el instanceof HTMLInputElement ||
      el instanceof HTMLTextAreaElement ||
      el instanceof HTMLSelectElement;
    const onFocusIn = (e) => isField(e.target) && lenis.stop();
    const onFocusOut = (e) => isField(e.target) && lenis.start();
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('focusout', onFocusOut);

    return () => {
      cancelAnimationFrame(frame);
      document.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('focusout', onFocusOut);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return null;
}

export default SmoothScroll;
